import axios from 'axios';
import { useToast } from "vue-toastification";

const apiAxios = axios;

apiAxios.defaults.baseURL = process.env.VUE_APP_API_BASE_URL;

export async function request(params) {
  return apiAxios({
    baseURL: process.env.VUE_APP_API_BASE_URL,
    ...params,
  })
  .catch(function(err) {
    console.log(err);
    if(err.response && err.response.data && err.response.data.code == '401') {
      const toast = useToast();
      toast.error('Sorry! Your session has expired. Please login again');
      sessionStorage.removeItem('superAvatarAuthToken');
    }
  });
}